<template>
  <div>
    <v-row no-gutters>
      <v-col class="py-2" cols="12">
        <sms-pattern-picker
          v-model="selectedRow"
          @reload="(e) => (rerender = e)"

        />
      </v-col>

      <v-col
        v-if="(selectedRow && Object.keys(selectedRow).length) || computedSmsType === 'campaign'"
        cols="12"
      >
        <pattern-inputs-generate
          v-model="computedMessageData"
          :is-campaign="!!selectedRow?.campId || computedSmsType === 'campaign'"
          :message="safeMessageForPattern"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import smsPatternPicker from "../../components/fragments/smsPatternPickerDigi.vue";
import PatternInputsGenerate from "@/view/components/fragments/patternInputsGenerateDigi.vue";
 import { SmsAxios } from "@/main";

export default {
  name: "DigikalaSellerShippingSettings",

  components: {
    smsPatternPicker,
    PatternInputsGenerate,
  },

  props: {
    patternId: {
      type: [Number, String],
      default: null,
    },
    messageData: {
      type: Object,
      default: () => ({}),
    },
    smsType: {
      type: String,
      default: "pattern", // 'pattern' | 'campaign'
    },
  },

  data() {
    return {
      selectedRow: {},
      rerender: true,

    };
  },

  computed: {
    computedPatternId: {
      get() {
        return this.patternId;
      },
      set(val) {
        
        this.$emit("update:patternId", val);
      },
    },
    computedMessageData: {
      get() {
        return this.messageData || {};
      },
      set(val) {
        this.$emit("update:messageData", val);
      },
    },
    computedSmsType: {
      get() {
        return this.smsType;
      },
      set(val) {
        this.$emit("update:smsType", val);
      },
    },
    
    safeMessageForPattern() {
      if (!this.selectedRow || !Object.keys(this.selectedRow).length) {
        return {
          content: "",
          messages: { name: "", text: [], gap: [], type: [] },
        };
      }
      return this.selectedRow;
    },
  },

 async mounted() {
    // if(this.smsType === 'pattern'){
    //  this.selectedRow = await this.fetchSinglePattern(this.patternId);
    // }
        const defaultMessage = {
      data1: {
        state: "userInfo",
        text: "name",
      },
      data2: {
        state: "userInfo",
        text: "phone",
      },
    };

    if (!this.value || !this.value.configs) {
      this.computedValue = {
          patternId: 487,
          smsType: "pattern",
          isActive: true,
          message: defaultMessage,
           };
    } else if (
      this.smsType === "pattern" && // اضافه کردن شرط برای جلوگیری از ست default در کمپین
      (!this.message ||
        !Object.keys(this.message).length)
    ) {
      this.computedValue = {
        ...this.computedValue,
        configs: {
          ...this.computedValue.configs,
          message: defaultMessage,
        },
      };
    }
    this.$nextTick(() => {
      if (this.computedPatternId) {
        this.$set(
          this.selectedRow,
          this.computedSmsType === "pattern" ? "id" : "campId",
          this.computedPatternId
        );
      }
    });
  },

  watch: {
  selectedRow: {
    deep: true,
    handler(val) {
      if (!val || !Object.keys(val).length) {
        this.computedPatternId = null;
        this.computedMessageData = {};
        return;
      }

      const isCampaign = !!val.campId;
      
      this.computedPatternId = isCampaign ? val.campId : (val.id || val.code || val.patternCode);
      this.computedSmsType = isCampaign ? "campaign" : "pattern";

      if (isCampaign) {
        this.computedMessageData = JSON.parse(JSON.stringify(val.messages || {}));
      } else {
        // 👈 اینجا! اگر content هنوز لود نشده (فقط id داریم)، متوقف شو
        if (!val.content) {
          return; 
        }
        this.syncMessageWithPattern(val);
      }
    },
  },
},

  methods: {
     async loadPatternData(id) {
      if (this.smsType === 'pattern' && id) {
        this.selectedRow = await this.fetchSinglePattern(id);
      }
    },
async fetchSinglePattern(id) {
  try {
    // تلاش برای پیدا کردن پترن از هر دو مسیر کاربر و عمومی
    // مسیر اول: پترن‌های کاربر
    let response = await SmsAxios.get(`text/user`, {
      params: { id: id, active: 1 }
    });
    let pattern = response.data?.data?.find(item => item.id == id);
    
    // مسیر دوم: اگر در پترن‌های کاربر نبود، در پترن‌های عمومی جستجو شود
    if (!pattern) {
      response = await SmsAxios.get(`text/public`, {
        params: { id: id, active: 1 }
      });
      pattern = response.data?.data?.find(item => item.id == id);
    }
    
    return pattern;
  } catch (e) {
    console.error("Failed to fetch single pattern detail", e);
    return null;
  }
},
    syncMessageWithPattern(pattern) {
      const matches = (pattern.content || "").match(/data\d+/g) || [];
      const currentMessage = this.computedMessageData || {};
      const newMessage = {};

      matches.forEach((key) => {
        if (currentMessage.hasOwnProperty(key)) {
          newMessage[key] = currentMessage[key];
        } else {
          newMessage[key] = { state: "data", text: "" };
        }
      });

      this.computedMessageData = {...newMessage};
    },
  },
};
</script>
